export default "__VITE_ASSET__Dw6Au7Dz__"